<template>
  <!-- Sidebar -->
  <div class="sidebar no-print" id="sidebar">
    <!--    <div  v-if="host === 'app.salesdue.com' || host === 'app.salesdue.com.local:4002'">-->
    <!--      <DefaultSidebar/>-->
    <!--    </div>-->
    <!--    <div  v-if="host === 'app.fastatext.com'-->
    <!--    || host === 'app.fastatext.com.local:4002'-->
    <!--    || host === 'customer.salesdue.com'-->
    <!--    || host === 'localhost:4002'-->
    <!--    || host === '192.168.0.11:4002'-->
    <!--    || host === 'localhost:4001'-->
    <!--    || host === '192.168.100.60:8080'-->
    <!--    || host === '0366-197-221-255-41.ngrok-free.app'">-->
    <!--      <SalesDueSidebar/>-->
    <!--    </div>-->
    <SalesDueSidebar/>
  </div>
  <!-- /Sidebar -->
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar'
import "vue-custom-scrollbar/dist/vueScrollbar.css"
import SalesDueSidebar from "./SalesDueSidebar";

export default {
  components: {
    // SmsSidebar,
    vueCustomScrollbar,
    //DefaultSidebar,
    SalesDueSidebar,
    // PosSidebar
  },
  computed: {
    currentPath() {
      return this.$route.name;
    },
    allowedRoutes() {
      return JSON.parse(localStorage.getItem('allowedRoutes'))
    },
    salesChannels() {
      return JSON.parse(localStorage.getItem('salesChannels'))
    },
  },
  data() {
    return {
      host: null,
      roleId: null,
      userId: null,
      selectedStoreId: null,
      permissions: [],
      settings: {
        suppressScrollX: true,
      },
      activeClass: 'active'
    };
  },
  methods: {
    scrollHandle(evt) {
    },
    upgradePackage() {
      // window.open('https://pay.salesdue.com/?amount=499&currency=USD&description=Monthly Subscription&reference='+localStorage.getItem('mid')+'&mid=5b3cc16c-9687-4f60-97e6-57de2b11218f'+'&returnUrl=https://customer.salesdue.com/payments/result', '_blank')
      window.open('http://localhost:3001/?amount=499&currency=USD&description=Monthly Subscription&reference=' + localStorage.getItem('mid') + '&mid=4ba75120-5e3c-41c3-a78a-2bc3998745bb' + '&returnUrl=http://localhost:4002/payments/result', '_blank')
    },
  },
  mounted() {
    this.host = location.host
    let currentRoutePath = this.$route.path

    // document.body.classList.remove('expand-menu')
    // document.body.classList.add('mini-sidebar')

    // if (currentRoutePath === "/pos"){
    //   document.body.classList.remove('expand-menu')
    //   document.body.classList.add('mini-sidebar')
    // } else {
    //   document.body.classList.remove('mini-sidebar')
    //   document.body.classList.add('expand-menu')
    // }
  }
}
</script>

<style>
.scroll-area {
  position: relative;
  margin: auto;
  height: calc(100vh - 60px);
  background-color: transparent !important;
}

.sidebar-menu ul li a.active {
  background-color: #65cf21 !important;
  color: #fff;
}

.sidebar-menu ul ul a.active {
  background-color: unset !important;
  color: #9fe870;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/MySidebar.vue